import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { setDispatchedActions, setRulesErrors } from '../store/rules.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IRulesState, RulesErrors } from '../store/rules.types'
import { getRulesSelector } from '../selectors'
import { mapRuleErrors, runRulesValidation } from '../../../utilities/runRulesValidation.util'
import { RulesConstants } from '../store/rules.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IRulesOptionsState } from '../../options/store/options.types'
import { getRulesOptionsSelector } from '../../options/selectors'

export function* runRule() {
  const rules: IRulesState = yield select(getRulesSelector)
  const { dispatchedActions, errors } = rules
  const rulesOptions: IRulesOptionsState = yield select(getRulesOptionsSelector)
  const { standardRules, xsdRules } = rulesOptions
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)

  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const { rulesErrors, idsOfRulesExecuted } = runRulesValidation(
        [...standardRules, ...xsdRules],
        pcrDoc,
        dispatchedActions
      )
      const rulesExecutedIdSet: Set<string> = new Set(idsOfRulesExecuted)

      const updatedErrorList: RulesErrors = [
        ...Object.values(errors)
          .flat()
          .filter((error) => !rulesExecutedIdSet.has(error.id)),
        ...rulesErrors,
      ]

      yield put(setRulesErrors(mapRuleErrors(updatedErrorList)))
      yield put(setDispatchedActions([]))
    } catch (e) {
      yield put(throwPcrException(`runRule() error: ${e}`))
    }
  }
}

export function* runRuleSaga() {
  yield takeLatest([RulesConstants.RUN_RULE], performWithMutexHOG, runRule)
}
